import Coverage from '@/modules/common/common/models/MID/Coverage'
import PetsHiringInsured from './PetsHiringInsured'

export default class PetsHiringInsuredRecovery extends PetsHiringInsured {
  coverages: Coverage[]

  constructor(data: any = {}) {
    super(data)

    this.coverages = data.coverages?.map((c: any) => new Coverage(c)) ?? []
  }
}
